export type PaymentFeeFields = {
  taxa_operadora_percentual?: number;
  valor_taxa_operadora?: number;
  valor_liquido?: number;
};

const normalizePaymentMethod = (value?: string) => String(value || "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toLocaleLowerCase("pt-BR");

export const isCardPayment = (value?: string) => {
  const normalized = normalizePaymentMethod(value);
  return normalized.includes("cartao") || normalized.includes("maquininha");
};

export const sanitizeCardFeePercent = (value: unknown) => {
  const parsed = parseMoneyBR(value);
  if (!Number.isFinite(parsed)) return 0;
  return Math.min(100, Math.max(0, parsed));
};

export const calculatePaymentFee = (grossValue: unknown, method?: string, percentValue?: unknown) => {
  const gross = Math.max(0, parseMoneyBR(grossValue));
  const percent = isCardPayment(method) ? sanitizeCardFeePercent(percentValue) : 0;
  const feeValue = roundMoney(gross * percent / 100);
  const netValue = roundMoney(gross - feeValue);
  return {
    taxa_operadora_percentual: percent,
    valor_taxa_operadora: feeValue,
    valor_liquido: netValue,
  };
};
import { parseMoneyBR, roundMoney } from "@/lib/money";

